import { useState, useEffect, useMemo, useCallback, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import {
  IdcardFilled,
  InfoCircleOutlined,
  DownOutlined,
  DownloadOutlined,
  ExclamationCircleOutlined,
  EditTwoTone
} from '@ant-design/icons'
import {
  Card,
  Row,
  Col,
  Button,
  Popover,
  Typography,
  Collapse,
  Tabs,
  Dropdown,
  Tooltip,
  Modal,
  Space,
  Menu
} from 'antd'
import Moment from 'react-moment'
import { formatMoney } from 'accounting-js'
import Icons from '@commonComponents/Icons'
import JobCancel from './job-cancel.component'
import JobComment from './contact-less/job-comment.component'
import DeliveryDetails from './contact-less/delivery-detail.component'
import JobIssue from './job-issue.component'
import OldJobReschedule from './job-reschedule.component'
import ItemsView from './items/items.component'
import Invoices from './invoices.component'
import {
  getFormatText,
  getOperationalModel,
  getCheckoutInfo,
  standardDate,
  isPickingInProgress
} from '../../flag-management.tools'
import { useHistory, useLocation } from 'react-router-dom'
import ChangeStoreModal from '@commonComponents/ChangeStoreModal'
import { downloadEvent, blockingPolicyUnlock, getItemByJob } from '../../flag-management.services'
import { getTimeZoneDifferentNumber, formatHourWithUtc } from '../../../../utils/dates'
import { downloadFile } from '../../../../utils/downloadFiles'
import { JobValidations } from './job-validations/job-validations.component'
import { AdditionalInfo } from '../../../../refactory/modules/jobs/infrastructure/job-detail/additional-info.component'
import moment from 'moment'
import { useGate } from 'statsig-react'
import { Can } from '../../../../refactory/modules/access-control/infrastructure/roles-permissions/access-control'
import { SubModulePerms } from '../../../../refactory/modules/access-control/domain/module'
import { ItemDrawerByJob } from '../../../../refactory/modules/jobs/infrastructure/job-detail/items/item-drawer-by-job.component'

import '../../flag-management.styles.less'
import { getItemsByJobUseCase } from '../../../../refactory/modules/jobs/application/get-items-by-job.use-case'
import { itemRepository } from '../../../../refactory/modules/jobs/infrastructure/odin-nebula-item.repository'
import { useHookstate } from '@hookstate/core'
import SelectRejectItemsModal from '../../../../refactory/modules/jobs/infrastructure/select-reject-items-modal.component'
import styled from 'styled-components'
import JobAddressEditModal from '../../../../refactory/modules/jobs/infrastructure/job-address/job-address-edit-modal.component'
import { getJob } from '../../../jobs/jobs.services'
import RescheduleJob from '../../../../refactory/modules/jobs/infrastructure/reschedule-job'
import { HistoricalContext } from '../../../../refactory/modules/jobs/infrastructure/job-detail/historical.context'
import { DECIMALS_MONEY } from '../../../../refactory/utils/moneyFormat'
import * as Icon from '@phosphor-icons/react'

const { Panel } = Collapse
const { TabPane } = Tabs

const TRUCK = 'Truck'
const CHECK_CIRCLE = 'CheckCircle'
const IMAGE_ICON = 'Image'
const INFO_ICON = 'Info'
const LIMIT_WORDS = 15
const AVAILABLE_EVENTS = ['PICKING_FINISHED']

const ICONS = {
  FULL_SERVICE: ['FullService'],
  PICK_AND_DELIVERY: ['Shopper', 'Driver'],
  PICK_AND_DELIVERY_WITH_STORAGE: ['Shopper', 'Package', 'Truck'],
  PICK_AND_COLLECT: ['Shopper'],
  PICK_AND_COLLECT_NO_TRANSFER: ['Shopper'],
  PICK_AND_DELIVERY_WITH_STORAGE_NO_TRANSFER: ['Shopper', 'Package', 'Truck']
}

const JobInfo = (props) => {
  const location = useLocation()
  const history = useHistory()
  const { job, isCancelled, isDelivered, currentUser, jobsSearch, featureFlags } = props
  const { user, client } = currentUser
  const { Text } = Typography
  const { t } = useTranslation()
  const [showBannerBlockingPolicy, setShowBannerBlockingPolicy] = useState(true)
  const [showJobCancel, setShowJobCancel] = useState(false)
  const [showModalBlockingPolicy, setShowModalBlockingPolicy] = useState(false)
  const [showJobComment, setShowJobComment] = useState(false)
  const [showDeliveryDetails, setShowDeliveryDetails] = useState(false)
  const [showJobIssue, setShowJobIssue] = useState(false)
  const [showJobReschedule, setShowJobReschedule] = useState(false)
  const [itemsVisible, setItemsVisible] = useState(false)
  const [paymentDetails, setPaymentDetails] = useState(false)
  const [showChangeStoreModal, setShowChangeStoreModal] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const [localItems, setLocalItems] = useState([])
  const [thereAreRejectedItems, setThereAreRejectedItems] = useState(false)
  const [deliveryTask, setDeliveryTask] = useState(null)
  const jobItems = useHookstate([])
  const isPhoneNumberDisabled = useGate('is_phone_number_disabled').value
  const isJobCancelActive = useGate('is_job_cancel_active').value
  const isNewRescheduleActive = useGate('is_reschedule_with_capacity_active').value
  const isReplacementProductV2Active = useGate('is_replacement_product_v2_active').value
  const isNewRejectItemsPostDeliveryActive = useGate('is_new_reject_items_active').value
  const isGetDetailJobByNebulaActive = useGate('is_get_detail_job_by_nebula_active').value
  const [isRejectItemsModalOpen, toggleRejectItemsModal] = useState(false)
  const [isEditDestinationModalOpen, setIsEditDestinationModalOpen] = useState(false)
  const orderIsRejectableAfterDelivered = useMemo(() => job.status === 'FINISHED', [job])
  const { getJobHistorical } = useContext(HistoricalContext)
  const showEditAddress = Can([SubModulePerms.JOB_GENERAL_CHANGE_ADDRESS]) && !isCancelled && !isDelivered()
  const orderIsRejectableBeforeDelivered = useMemo(() => {
    const { tasks } = job
    const deliveryTaks = tasks.filter((task) => {
      return task.steps.filter((step) => step.type.name === 'DELIVERING')[0]
    })[0]
    let isRejectableByClient = false
    let isRejectableByDriver = false

    if (deliveryTaks) {
      const { steps } = deliveryTaks
      isRejectableByClient = steps.filter(({ type, status }) => type.name === 'DELIVERING' && status === 'DOING')[0]
      isRejectableByDriver = steps.filter(
        ({ type, status }) =>
          ['TRANSFERRING_FROM', 'TRANSFERRING_FROM_STORAGE_TO_DELIVERY'].includes(type.name) && status === 'DOING'
      )[0]
    }

    return isRejectableByClient || isRejectableByDriver
  }, [job])

  const isSkuAndItemsCountActive = useGate('is_sku_and_items_count_active').value

  if (isSkuAndItemsCountActive) {
    // TODO: Implement SKU and items count
  }

  const incidenceItems = useMemo(
    () =>
      localItems.filter(
        (item) =>
          !!item?.rejectionInformation &&
          (item?.rejectionInformation?.claimState === null || item?.rejectionInformation?.claimState === 'IN_PROGRESS')
      ),
    [localItems]
  )

  const orderIsRejectable = useMemo(
    () => (orderIsRejectableAfterDelivered || orderIsRejectableBeforeDelivered) && job.status !== 'CANCELLED',
    [orderIsRejectableAfterDelivered, orderIsRejectableBeforeDelivered, job]
  )

  const rejectableItems = useMemo(
    () =>
      localItems.filter(
        (item) =>
          item.state === 'ADDED' &&
          !item?.claimInformation?.availableClaimActions.includes('REJECTION_NOT_ALLOWED') &&
          !item?.rejectionInformation
      ),
    [localItems]
  )

  const existsRescheduleInPath = () => location.pathname.split('/').includes('reschedule')

  const handleIncidencesClick = useCallback(() => {
    history.push({
      pathname: `/orders/${job.id}/incidence/resolution`
    })
  }, [history, job.id])

  const showPaymentDetails = (_) => {
    if (!location.pathname.includes('invoices')) {
      history.push(`${location.pathname}/invoices`)
    } else if (location.pathname.includes('invoices') && paymentDetails) {
      history.replace(location.pathname.split('/invoices')[0])
    }
    setPaymentDetails(!paymentDetails)
  }

  const showItems = () => {
    if (!location.pathname.includes('items')) {
      history.push(`${location.pathname}/items`)
    } else if (location.pathname.includes('items') && itemsVisible) {
      history.replace(location.pathname.split('/items')[0])
    }
    setItemsVisible(!itemsVisible)
  }

  useEffect(() => {
    const lastTaskIndex = props.job.tasks.length - 1
    setDeliveryTask(props.job.tasks[lastTaskIndex])

    if (location.pathname.includes('items')) {
      showItems()
    } else if (location.pathname.includes('cancel')) {
      if (!isCancelled) {
        handleJobCancel()
      }
    } else if (location.pathname.includes('issue')) {
      handleJobIssue()
    } else if (location.pathname.includes('change-store')) {
      handleChangeStore()
    } else if (existsRescheduleInPath()) {
      handleJobReschedule()
    } else if (location.pathname.includes('invoices')) {
      showPaymentDetails()
    }
  }, [])

  const handleJobCancel = () => {
    if (!location.pathname.includes('cancel')) {
      history.push(`${location.pathname}/cancel`)
    } else if (location.pathname.includes('cancel') && showJobCancel) {
      history.replace(location.pathname.split('/cancel')[0])
    }
    setShowJobCancel(!showJobCancel)
  }

  const handleJobIssue = () => {
    if (!location.pathname.includes('issue')) {
      history.push(`${location.pathname}/issue`)
    } else if (location.pathname.includes('issue') && showJobIssue) {
      history.replace(location.pathname.split('/issue')[0])
    }
    setShowJobIssue(!showJobIssue)
  }

  const handleChangeStore = () => {
    if (!location.pathname.includes('change-store')) {
      history.push(`${location.pathname}/change-store`)
    } else if (location.pathname.includes('change-store') && showChangeStoreModal) {
      history.replace(location.pathname.split('/change-store')[0])
    }
    setShowChangeStoreModal(!showChangeStoreModal)
  }

  const getPathBeforeReschedule = (url) => {
    const rescheduleIndex = url.split('/').indexOf('reschedule')
    if (rescheduleIndex === -1) {
      return url
    }
    return url.split('/').slice(0, rescheduleIndex).join('/')
  }

  const handleJobReschedule = () => {
    if (!existsRescheduleInPath()) {
      history.push(`${location.pathname}/reschedule`)
    } else if (existsRescheduleInPath() && showJobReschedule) {
      history.replace(getPathBeforeReschedule(location.pathname))
    }
    setShowJobReschedule(!showJobReschedule)
  }

  const handleJobComment = () => {
    setShowJobComment(!showJobComment)
  }

  const handleDeliveryDetails = () => {
    setShowDeliveryDetails(!showDeliveryDetails)
  }

  const onDownloadJobEvent = async (jobNumber, uuid, eventName) => {
    try {
      setDownloading(true)
      const event = await downloadEvent(uuid, eventName)
      downloadFile(`${jobNumber}-${eventName}`, JSON.stringify(event))
    } catch (error) {
      console.error('Something went wrong downloading the job event')
    } finally {
      setDownloading(false)
    }
  }

  const showBannerDifferentsTimeZone = (timeZoneNumber, timeZone) => {
    if (timeZoneNumber !== null) {
      return (
        <div className='div-info-different-timezone'>
          <Row>
            <Col span={2}>
              <Icons iconName='ClockYellow' />
            </Col>
            <Col span={15}>
              <label className='title-banner-time-zone'>{t('jobs.jobList.ordenToAnotherTime')}</label>
              <label className='message-banner-time-zone'>{t('jobs.jobList.theOrdenShowAnotherTime')}</label>
            </Col>
            <Col span={7}>
              <label className='hour-banner-time-zone'>
                <Moment format='LT' tz={timeZone}>
                  {standardDate(moment())}
                </Moment>
              </label>
              <label className='banner-time-zone'>{timeZone}</label>
            </Col>
          </Row>
        </div>
      )
    }
    return null
  }

  const findDeliveryOptions = (methodName, deliveryOptions = []) => {
    return deliveryOptions.find(({ method }) => method === methodName) || null
  }

  const contactLess = findDeliveryOptions('CONTACT_LESS', job ? job.deliveryOptions : [])

  const rejectedForItemsByUser = () => {
    localItems.forEach((item) => {
      if (item.rejected && item.rejected.rejectedByUser > 0) {
        setThereAreRejectedItems(true)
      }
    })
  }

  const actionButtons = () => {
    let jobButtons = []

    if (Can([SubModulePerms.JOB_GENERAL_MOVE_STORE])) {
      jobButtons.push({
        id: 'change-job-store-btn',
        label: t('changeJobStore'),
        type: 'default',
        action: handleChangeStore,
        disabled: isCancelled || isDelivered() || !isPickingInProgress(job.tasks)
      })
    }

    if (Can([SubModulePerms.JOB_GENERAL_RESCHEDULE])) {
      jobButtons.push({
        id: 'reschedule-btn',
        label: t('jobs.job.info.reschedule'),
        type: 'default',
        action: handleJobReschedule,
        disabled: isCancelled || isDelivered()
      })
    }

    if (localItems.length > 0 && !thereAreRejectedItems) {
      rejectedForItemsByUser()
    }

    if (
      !isNewRejectItemsPostDeliveryActive &&
      job.itemsStatusCount &&
      (job.itemsStatusCount.rejected > 0 || thereAreRejectedItems)
    ) {
      jobButtons.push({
        id: 'job-issue',
        label: t('jobs.job.info.issue'),
        type: 'default',
        action: handleJobIssue,
        disabled: false
      })
    }

    if (!isJobCancelActive && Can([SubModulePerms.JOB_GENERAL_CANCEL])) {
      jobButtons.push({
        id: 'cancel-order-with-reason-987123',
        label: t('jobs.job.info.cancel'),
        type: 'danger',
        action: handleJobCancel,
        disabled: isCancelled || isDelivered()
      })
    }

    const getButtons = () => {
      return (
        <div className='manage-job-buttons'>
          {jobButtons.map(({ label, id, action, type, disabled }, idx) => {
            return (
              <div
                className={`job-button-${type} ${disabled ? 'disabled' : ''}`}
                onClick={() => !disabled && action()}
                key={idx}
                id={id}
              >
                <span>{label}</span>
              </div>
            )
          })}
        </div>
      )
    }

    return (
      <>
        {!!jobButtons.length && (
          <div className='job-buttons-container'>
            <Dropdown.Button trigger={['click']} overlay={getButtons()} icon={<DownOutlined />}>
              {t('manageOrder')}
            </Dropdown.Button>
          </div>
        )}
      </>
    )
  }

  const getResourceName = () => {
    const checkoutInfo = getCheckoutInfo(job.tasks)
    if (checkoutInfo && checkoutInfo.resource) {
      const {
        resource: { firstName, lastName }
      } = checkoutInfo
      if (firstName) {
        return `${firstName} ${lastName}`
      }
    }
    return ' - '
  }

  const getLabel = (title, content, key) => (
    <dl key={key}>
      <dt>
        <b>{title}</b>
      </dt>
      <dd>{content}</dd>
    </dl>
  )

  const showPaymentMethodTextAndIcon = (method) => {
    switch (method) {
      case 'CASH':
        return <Icons iconName='PaymentMethodCash' />
      case 'REPAID':
        return <Icons iconName='PaymentMethodCreditCard' />
      case 'PAYMENT_LINK':
        return <Icons iconName='PaymentMethodPaymentLink' />
      case 'PAYMENT_TERMINAL':
        return <Icons iconName='PaymentMethodPaymentTerminal' />
      case 'TRANSFER':
        return <Icons iconName='PaymentMethodTransfer' />
      case 'LOYALTY_CARD':
        return <Icons iconName='PaymentMethodLoyaltyCard' />
      default:
        break
    }
  }

  const showPaymentStatusTextAndIcon = (status) => {
    switch (status) {
      case 'succeeded':
        return <Icons iconName='PaymentStatusSuccess' />
      case 'failed':
        return <Icons iconName='PaymentStatusFailed' />
      case 'changed':
        return <Icons iconName='PaymentStatusChanged' />
      case 'reverted':
        return <Icons iconName='PaymentStatusReverted' />
      case 'in_progress':
        return <Icons iconName='PaymentStatusInProgress' />
      case 'pending':
        return <Icons iconName='PaymentStatusPending' />
      default:
        break
    }
  }

  const changeStatusBlockingPolicy = async () => {
    await blockingPolicyUnlock(job.id, {})
    const response = await getJob(job.id)
    if (response) {
      props.setJob(response)
    }
    setShowModalBlockingPolicy(false)
    setShowBannerBlockingPolicy(false)
  }

  const showModalBlockingPolicyAction = () => {
    setShowModalBlockingPolicy(true)
  }

  const handleClickEditDestination = () => {
    setIsEditDestinationModalOpen(true)
  }

  const closeEditDestinationModal = async (isEdited) => {
    setIsEditDestinationModalOpen(false)
    if (isEdited) {
      if (isGetDetailJobByNebulaActive) {
        props.setSelectedJob()
      } else {
        const _job = await getJob(job.id)
        props.setSelectedJob(_job)
      }
    }
  }

  const updateInfoJob = async (state) => {
    const updateJob = await blockingPolicyUnlock(job.id, {
      paymentStatus: state
    })
    if (updateJob) {
      const response = await getJob(job.id)
      if (response) {
        props.setJob(response)
      }
    }
  }
  const generalInfo = (symbolValue) => {
    const totalItems =
      job.itemsStatusCount?.added +
      job.itemsStatusCount?.removed +
      job.itemsStatusCount?.rejected +
      job.itemsStatusCount?.pending
    const tooltipTextPaymentMethod = t(job.paymentInfo?.payment?.method)
    const textPaymentMethod = t(job.paymentInfo?.payment?.method).toUpperCase()
    const textPaymentMethodDetails = t(job.paymentInfo?.payment?.methodDetails).toUpperCase()
    const textPaymentReference = t(job.paymentInfo?.payment?.reference).toUpperCase()
    const paymentStatus = job.paymentInfo?.payment?.paymentStatus
      ? job.paymentInfo?.payment?.paymentStatus.toLowerCase()
      : 'pending'
    const classPaymentStatus = `payment-status-${paymentStatus}`
    return (
      <>
        <div className='blue-line'>
          <Icons iconName='BlueLine' />
        </div>
        <Row gutter={16}>
          <Col span={12}>
            <dl className='job-addresses'>
              <dt>{t('jobs.job.info.origin')}:</dt>
              <dd>
                <b>{job.origin.name} </b>
                <Popover
                  placement='bottom'
                  content={
                    <div>
                      <Text strong>{t('jobs.job.info.address_2')}:</Text>
                      <p>
                        <b>{job.origin.address}, </b>
                        {`"${job.origin.description}"`}
                      </p>
                      <Text strong>{t('jobs.job.info.city')}:</Text>
                      <p>{job.origin.city}</p>
                    </div>
                  }
                >
                  <InfoCircleOutlined className='secondary-text' />
                </Popover>
              </dd>
            </dl>
            {getLabel(
              `${t('jobs.job.info.slot')}:`,
              <>
                <Moment format='LLL'>{formatHourWithUtc(standardDate(job.storeTzSlotFrom))}</Moment>
                {' - '}
                <Moment format='LT'>{formatHourWithUtc(standardDate(job.storeTzSlotTo))}</Moment>
              </>
            )}
            {getLabel(
              `${t('jobs.job.info.operationModel')}:`,
              <div>
                {t(`job-models.${job.operationModel}`)}{' '}
                {ICONS[job.operationModel] &&
                  ICONS[job.operationModel].map((iconName, idx) => (
                    <Icons className='operational-model-icons' key={idx} iconName={iconName} />
                  ))}
              </div>
            )}
            {getLabel(
              `${t('jobs.job.info.items')}:`,
              <Space
                direction='horizontal'
                type='small'
                style={{
                  display: 'flex'
                }}
              >
                <Button id='show-items' type='dashed' size='small' onClick={showItems}>
                  <u>{`${totalItems} ${t('jobs.job.info.items')}`}</u>
                </Button>
                {isNewRejectItemsPostDeliveryActive && job.status !== 'CANCELLED' && incidenceItems.length > 0 && (
                  <IncidenceWarningButton
                    size='small'
                    icon={<ExclamationCircleOutlined />}
                    onClick={handleIncidencesClick}
                  >
                    {incidenceItems.length} {t('jobs.job.info.incidences')}
                  </IncidenceWarningButton>
                )}
                {isNewRejectItemsPostDeliveryActive && orderIsRejectable && rejectableItems.length > 0 && (
                  <Button type='secundary' size='small' onClick={() => toggleRejectItemsModal(true)}>
                    + {t('jobs.job.info.createIncidence')}
                  </Button>
                )}
              </Space>
            )}
            {getLabel(
              `${t('jobs.job.info.created')}:`,
              <Moment format='LLL'>{formatHourWithUtc(standardDate(job.storeTzCreatedAt))}</Moment>
            )}
            {job.jobComment && (
              <dl className='job-addresses'>
                <dt>
                  <b>{t('jobs.job.info.orderComment')}: </b>
                </dt>
                <dd className='secondary-text margin-comment'>
                  {getFormatText(job.jobComment, LIMIT_WORDS)}
                  <br />
                  {job.jobComment.split(' ').length > LIMIT_WORDS ? (
                    <Button type='dashed' size='small' onClick={handleJobComment}>
                      {t('jobs.job.info.showMore')}
                    </Button>
                  ) : null}
                </dd>
              </dl>
            )}
          </Col>
          <Col span={12}>
            <dl className='job-addresses'>
              <dt>{t('jobs.job.info.destination')}:</dt>
              {Can([SubModulePerms.JOB_GENERAL_ADDRESS]) ? (
                <dd style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                  <b>{job.destination.address} </b>
                  <Popover
                    placement='bottom'
                    content={
                      <div>
                        {job.destination.addressTwo || job.destination.description ? (
                          <>
                            <Text strong>{t('jobs.job.info.address_2')}:</Text>
                            <p>
                              {job.destination.addressTwo && <b>{job.destination.addressTwo}, </b>}
                              {job.destination.description && `"${job.destination.description}"`}
                            </p>
                          </>
                        ) : null}
                        <Text strong>{t('jobs.job.info.city')}:</Text>
                        <p>{job.destination.city}</p>
                      </div>
                    }
                  >
                    <InfoCircleOutlined className='secondary-text' />
                  </Popover>
                  {showEditAddress && (
                    <EditTwoTone onClick={handleClickEditDestination} style={{ cursor: 'pointer' }} />
                  )}
                </dd>
              ) : (
                '-'
              )}
            </dl>
            {getLabel(`${t('billedBy')}:`, getResourceName())}
            {getLabel(
              `${t('jobs.job.info.paymentMethod')}:`,

              <label>
                {textPaymentMethodDetails
                  ? textPaymentMethod + ' / ' + textPaymentMethodDetails + ' / ' + textPaymentReference
                  : textPaymentMethod + ' / ' + textPaymentReference}
                <Tooltip placement='right' title={tooltipTextPaymentMethod}>
                  <span>{showPaymentMethodTextAndIcon(job.paymentInfo?.payment?.method)}</span>
                </Tooltip>
              </label>
            )}
            {getLabel(
              `${t('jobs.job.info.collect')}:`,
              <>
                <Button type='dashed' size='small' id='show-payment-details' onClick={showPaymentDetails}>
                  <u>
                    {formatMoney(
                      job?.paymentInfo?.prices?.orderValue !== job.updatedPrices?.paymentValue
                        ? job?.paymentInfo?.prices?.orderValue
                        : job.updatedPrices?.paymentValue,
                      symbolValue
                    )}
                  </u>
                </Button>
                <Popover
                  placement='bottom'
                  content={
                    <div>
                      <p>{t('jobs.job.info.paymentDetailsMessage')}</p>
                    </div>
                  }
                >
                  <InfoCircleOutlined className='secondary-text info-icon' />
                </Popover>
              </>
            )}
            {getLabel(
              `${t('paymentStatus')}:`,
              <label className={classPaymentStatus}>
                {t(paymentStatus)} {showPaymentStatusTextAndIcon(paymentStatus)}
              </label>
            )}
            {getLabel(
              `${t('paymentStatusDetail')}:`,
              <>
                <label>
                  {job.paymentInfo?.payment.paymentStatusDetails
                    ? job.paymentInfo?.payment.paymentStatusDetails
                    : t('empty-text')}
                </label>
              </>
            )}

            {contactLess && (
              <dl className='delivery-details'>
                <dt>
                  <b>{t('jobs.job.info.devDetails')}:</b>
                </dt>
                <dd>
                  <div>
                    <Icons iconName={TRUCK} /> {getOperationalModel(t)[job.operationModel]}
                  </div>
                  <div>
                    <Icons iconName={CHECK_CIRCLE} /> {t('jobs.job.info.noContact')}
                    <Popover
                      placement='bottom'
                      content={
                        <div>
                          <Text strong>{t('jobs.job.info.leave')}:</Text>
                          <p>{t(`${contactLess.comment}`)}</p>
                          {contactLess.cashReceiver && (
                            <>
                              <Text strong>{t('jobs.job.info.leaveCash')}:</Text>
                              <p>{contactLess.cashReceiver}</p>
                              <p>{`${t('jobs.job.info.contactLess.phone')} ${contactLess.phoneNumber}`}</p>
                            </>
                          )}
                        </div>
                      }
                    >
                      {' '}
                      <Icons className='secondary-text' iconName={INFO_ICON} />
                    </Popover>
                  </div>
                  {isDelivered() ? (
                    <div>
                      <Icons iconName={IMAGE_ICON} /> {t('jobs.job.info.devPhoto')}
                      <br />
                      <Button id='show-delivery-details' type='dashed' size='small' onClick={handleDeliveryDetails}>
                        {t('jobs.job.info.detailView')}
                      </Button>
                    </div>
                  ) : null}
                </dd>
              </dl>
            )}
            {job.paymentInfo?.payment.blockingPolicy &&
            job.paymentInfo?.payment.blockingPolicy !== 'UNBLOCKED' &&
            showBannerBlockingPolicy ? (
              <div className='div-blocking-policy'>
                <Row className='div-blocking-policy-row'>
                  <Col className='div-blocking-policy-icon'>
                    <Icon.WarningIcon size={22} color='#FAAD14' weight='bold' />
                  </Col>
                  <Col className='div-blocking-policy-text'>
                    <label className='text-blocking-policy'>{t('orderBloked')}</label>
                    {job.paymentInfo.payment.paymentStatus ? (
                      <label className='link-blocking-policy' onClick={showModalBlockingPolicyAction}>
                        {t('unblock')}
                      </label>
                    ) : (
                      <Dropdown
                        placement='bottomRight'
                        overlay={
                          <Menu className='dropdown-blocking-policy'>
                            <Menu.Item
                              key={'itemBlocked0'}
                              className='dropdown-blocking-policy-item'
                              onClick={() => updateInfoJob('IN_PROGRESS')}
                            >
                              {t('jobs.job.info.change-payment-status-in-progress')}
                            </Menu.Item>
                            <Menu.Item
                              key={'itemBlocked1'}
                              className='dropdown-blocking-policy-item'
                              onClick={() => updateInfoJob('SUCCEEDED')}
                            >
                              {t('jobs.job.info.change-payment-status-completed')}
                            </Menu.Item>
                          </Menu>
                        }
                        trigger={['click']}
                      >
                        <div className='space-blocking-policy'>
                          <label className='link-blocking-policy'>{t('unblock')}</label>
                          <Icon.CaretDownIcon size={16} color='#1677FF' weight='bold' />
                        </div>
                      </Dropdown>
                    )}
                  </Col>
                </Row>
              </div>
            ) : null}
          </Col>
        </Row>
        <Modal
          visible={showModalBlockingPolicy}
          onOk={changeStatusBlockingPolicy}
          onCancel={() => setShowModalBlockingPolicy(false)}
          footer={[]}
        >
          <Row>
            <Col span={4}></Col>
            <Col span={16}>
              <label className='title-modal-blocking-policy'>{t('areYouSureYouUnlockTheOrder')}</label>
              <label className='description-modal-blocking-policy'>{t('youWillNotBeAbleToUndoThisAction')}</label>

              <button className='button-ok-blocking-policy' onClick={changeStatusBlockingPolicy}>
                <span style={{ margin: 'auto' }}>{t('yes')}</span>
              </button>
              <button className='button-cancel-blocking-policy' onClick={() => setShowModalBlockingPolicy(false)}>
                <span style={{ margin: 'auto' }}>{t('cancel')}</span>
              </button>
            </Col>
            <Col span={4}></Col>
          </Row>
        </Modal>
      </>
    )
  }

  const clientInfo = (jobInfo) => {
    const hideClientId = featureFlags?.hideClientId
    const {
      receiver: { firstName, lastName, phoneNumber, email, identification }
    } = jobInfo
    let receiverIdentification = null
    if (identification && identification.number) {
      const identificationType = identification.type + ' ' || ''
      receiverIdentification = `${identificationType}${identification.number}`
    } else if (typeof identification === 'string') {
      receiverIdentification = identification
    }

    const receiverPhoneNumber = isPhoneNumberDisabled ? '******' : phoneNumber || ' - '

    return (
      <Row gutter={16}>
        <Col span={12}>
          {getLabel(`${t('jobs.job.info.receiver')}:`, `${firstName} ${lastName}`)}
          {Can([SubModulePerms.JOB_GENERAL_CLIENT_INFO]) && (
            <>
              {getLabel(`${t('jobs.job.info.phone')}:`, receiverPhoneNumber)}
              {getLabel(`${t('jobs.job.info.email')}:`, email || ' - ')}
              {receiverIdentification &&
                hideClientId !== 'true' &&
                getLabel(`${t('identification')}:`, receiverIdentification)}
            </>
          )}
        </Col>
      </Row>
    )
  }

  const jobEvents = ({ uuid, jobNumber }) => {
    return (
      <div className='job-info-tabs-job-events'>
        {AVAILABLE_EVENTS.map((event) => {
          return (
            <div className='job-info-tabs-job-events-event' key={event}>
              <b>{t(event)}:</b>
              <span>{t('eventPayload')}</span>
              <Button
                type='link'
                icon={<DownloadOutlined />}
                loading={downloading}
                onClick={() => onDownloadJobEvent(jobNumber, uuid, event)}
              >
                {t('download')}
              </Button>
            </div>
          )
        })}
      </div>
    )
  }

  const getItems = async () => {
    setLocalItems([])
    setThereAreRejectedItems(false)
    const { job } = props
    if (isReplacementProductV2Active) {
      const response = await getItemsByJobUseCase(itemRepository)(job.id)
      jobItems.set(response)
    } else {
      if (isGetDetailJobByNebulaActive && job?.items) {
        setLocalItems((_) => job.items)
      } else {
        const items = await getItemByJob(job.id)
        setLocalItems(items)
      }
    }
  }

  useEffect(() => {
    getItems()
  }, [props.job])

  if (job) {
    const moneyFormat =
      localStorage.getItem('i18nextLng') === 'pt-br' ? { thousand: '.', decimal: ',' } : { thousand: ',', decimal: '.' }
    const symbolValue = {
      symbol: `${job.logisticCostCurrency} `,
      format: '%v %s',
      precision: DECIMALS_MONEY[job.logisticCostCurrency] || DECIMALS_MONEY.default,
      ...moneyFormat
    }
    const userInfo = JSON.parse(localStorage.getItem('user_info'))
    const timeZone = job.storeTimezone ? job.storeTimezone : userInfo.user.client.timeZone
    const timeZoneNumber = getTimeZoneDifferentNumber(timeZone)

    const title = (
      <Space direction='vertical' size={4}>
        <Space>
          {`${t('jobs.job.info.title')} `}
          <span>{job.jobNumber}</span>
        </Space>
        <Text type='secondary'>ID: {job.uuid}</Text>
      </Space>
    )

    return (
      <>
        <Card title={title} extra={actionButtons()} bordered={false} className='job-info'>
          <Row>
            <Col span={16} offset={4}>
              {showBannerDifferentsTimeZone(timeZoneNumber, timeZone)}
            </Col>
          </Row>

          <Collapse className='jobInfo-card' bordered={false} defaultActiveKey={['1']} expandIconPosition='right'>
            <Panel
              header={
                <div>
                  <IdcardFilled className='id-card-color' />
                  <b>{` ${t('jobs.job.info.general')}`}</b>
                </div>
              }
              key='1'
            >
              <Tabs defaultActiveKey='1'>
                <TabPane className='job-info-tabs' tab={t('jobs.job.info.general')} key='1'>
                  {generalInfo(symbolValue)}
                </TabPane>
                <TabPane id='job-info-client' className='job-info-tabs' tab={t('jobs.job.info.client')} key='2'>
                  {clientInfo(job)}
                </TabPane>
                {job.externalData && job.externalData.backoffice && (
                  <TabPane
                    id='job-info-additional-info'
                    className='job-info-tabs'
                    tab={t('jobs.job.info.externalData')}
                    key='3'
                  >
                    <AdditionalInfo
                      externalData={job.externalData}
                      setSelectedJob={props.setSelectedJob}
                      jobId={props.job.id}
                      jobUuid={props.job.uuid}
                      deliveryTask={deliveryTask}
                      store={props.store}
                      jobsSearch={props.jobsSearch}
                      timezone={props.tz}
                    />
                  </TabPane>
                )}

                {featureFlags?.requireSaveEvents === 'true' && Can([SubModulePerms.JOB_GENERAL_EVENTS]) && (
                  <TabPane id='job-info-job-events' className='job-info-tabs' tab={t('jobEvents')} key='4'>
                    {jobEvents(job)}
                  </TabPane>
                )}
                {(job.deliveryValidations || job.pickupCode || job.deliveryOptions) && (
                  <TabPane tab={t('jobs.job.info.data-validation.title')}>
                    <JobValidations job={job} />
                  </TabPane>
                )}
              </Tabs>

              {itemsVisible && !isReplacementProductV2Active && (
                <ItemsView
                  {...props}
                  jobId={job.id}
                  jobUuid={job.uuid}
                  items={job.items}
                  jobTasks={job.tasks}
                  currency={job.logisticCostCurrency}
                  visible={itemsVisible}
                  handleItems={showItems}
                  client={client}
                  symbolValue={symbolValue}
                />
              )}

              {itemsVisible && isReplacementProductV2Active && (
                <ItemDrawerByJob
                  items={jobItems}
                  jobId={job.id}
                  currencyCode={job.logisticCostCurrency}
                  showItemDrawer={itemsVisible}
                  onShowOrHideItemDrawer={showItems}
                  job={props.job}
                  clientLogoURL={props.currentUser.clientLogoURL}
                />
              )}

              {showJobCancel && <JobCancel {...props} visible={showJobCancel} handleJobCancel={handleJobCancel} />}
              {showJobIssue && (
                <JobIssue
                  {...props}
                  jobId={job.id}
                  jobUuid={job.uuid}
                  visible={showJobIssue}
                  handleJobIssue={handleJobIssue}
                  timeZone={timeZone}
                  checkoutInfo={getCheckoutInfo(job.tasks)}
                />
              )}
              {showJobReschedule && (
                <>
                  {isNewRescheduleActive ? (
                    <>
                      {job && localItems.length > 0 && (
                        <RescheduleJob
                          handleOnReschedule={() => {
                            handleJobReschedule()
                            if (isGetDetailJobByNebulaActive) {
                              if (jobsSearch) {
                                props.setSelectedJob()
                              }
                            } else {
                              getJobHistorical(job.id)
                              setTimeout(async () => {
                                if (jobsSearch) {
                                  const response = await getJob(job.id)
                                  props.setSelectedJob(response)
                                  props.setJob(response)
                                }
                              }, 3000)
                            }
                          }}
                          visible={showJobReschedule}
                          job={job}
                          handleClose={handleJobReschedule}
                          items={localItems}
                        />
                      )}
                    </>
                  ) : (
                    <OldJobReschedule
                      {...props}
                      jobId={job.id}
                      visible={showJobReschedule}
                      handleJobReschedule={handleJobReschedule}
                      selectedJob={job}
                    />
                  )}
                </>
              )}
              {showChangeStoreModal ? (
                <ChangeStoreModal
                  timeZone={timeZone}
                  {...props}
                  title={t('changeJobStore')}
                  visible={showChangeStoreModal}
                  handleVisible={handleChangeStore}
                  translation={t}
                />
              ) : null}
              {paymentDetails && (
                <Invoices
                  jobId={job.id}
                  paymentInfo={job.paymentInfo}
                  updatedPrices={job.updatedPrices}
                  jobNumber={job.reference}
                  copy={t}
                  invoices={job.invoices}
                  checkoutInfo={getCheckoutInfo(job.tasks)}
                  visible={paymentDetails}
                  handleView={showPaymentDetails}
                  timeZone={timeZone}
                  symbolValue={symbolValue}
                  setSelectedJob={props.setSelectedJob}
                  jobsSearch={jobsSearch}
                  user={user}
                />
              )}
              {job.jobComment && showJobComment && (
                <JobComment {...props} visible={showJobComment} handleJobComment={handleJobComment} />
              )}
              {contactLess && showDeliveryDetails && (
                <DeliveryDetails
                  {...props}
                  visible={showDeliveryDetails}
                  handleDeliveryDetails={handleDeliveryDetails}
                  contactLess={contactLess}
                  tz={timeZone}
                />
              )}
            </Panel>
          </Collapse>
          {isNewRejectItemsPostDeliveryActive && (
            <SelectRejectItemsModal
              jobId={job.id}
              isOpen={isRejectItemsModalOpen}
              onClose={() => toggleRejectItemsModal(false)}
              items={rejectableItems}
            />
          )}
        </Card>

        {isEditDestinationModalOpen && (
          <JobAddressEditModal onClose={closeEditDestinationModal} destination={job.destination} jobUUID={job.uuid} />
        )}
      </>
    )
  }

  return null
}

const IncidenceWarningButton = styled(Button)`
  background-color: #ffccc6 !important;
  border: 0px !important ;
  color: #cf1423 !important;
  &:hover {
    border: 0px !important ;
    color: #cf1423 !important;
  }
`

export default JobInfo
